import { createStore } from 'vuex'
import { db, loginsRef, usersRef, roundsRef, unlockedRef/*,passwordRef, endTimeRef*/ } from '../firebase'
import { ref as dbRef, get as getVal, set as setVal, push as dbPush, serverTimestamp, onDisconnect } from 'firebase/database'

export default createStore({
  state: {
    clientWidth: window.innerWidth,
    moduleTitle: 'RUKOBIA® National Sales Meeting', // Shows up in the browser tab title.
    moduleAssetFolderName: 'alpha', // The name of the folder under public/assets/modules/ where you're storing the image assets for the module.
    questionTime: 60, // Default number of seconds the user will have to answer a question.  Can be overridden on a per-question basis.
    questionTimeDelay: 15, // Default number of seconds that pass before a question will start its countdown.  Can be overridden on a per-question basis.
    questionFloatDelay: 2, // Time between each component of question screen floating in; [2 seconds for first question, changes to .75 after]
    breakpoints: {
      mob: 736,
      tab: 1024
    },
    disclaimer: '<p>FOR TRAINING PURPOSES ONLY. NOT FOR DISTRIBUTION TO OR USE WITH HEALTHCARE PROFESSIONALS.</p>', // Disclaimer that shows up at the bottom of the game
    users: [], // loads all users from firebase on app load for use with leaderboard
    rounds: [], // loads all rounds from firebase on app load
    unlocked: false, // determines whether users can start rounds
    currentUser: null,
    currentRound: null,
    currentQuestionID: null, // probably user question ID; master question ID only seems applicable for reporting post-event/activity
    currentView: 'welcome', // rotates between 'welcome', 'instructions', 'home', and 'question'
    errorMessage: '',
    lockErrorModal: false,
    showErrorModal: false,
    showLeaderboardModal: false,
    showPerformanceModal: false,
    showHelpModal: false,
    showLoginModal: false,
    showLogoutModal: false,
    showUserModal: false,
    showUserErrorMessage: false,
    userErrorMessage: '',
    showLoginErrorMessage: false,
    loginErrorMessage: '',
    skipToEnd: false, // toggled by login sequence -- if user has completed game or round/game hit deadline, send to end screen after login
    disableNavItems: false, // toggled by the current game state -- locks user out of nav items while a question is running
    randomizedQuestionOrder: true, // whether you want the questions to follow the master question ID order or the user question ID order
    showLeaderboardRegions: true, // whether you want to show the region for the reps on the leaderboard and reports
    leaderboardMaxLength: 25, // cap at the leaderboard length at this many users.  can set to something like 9999 if you want to display everyone
    heartbeatIntervalID: null,
  },
  mutations: {
    onResize(state, newSize){
      state.clientWidth = newSize;
    },
    login(state, returnedUser){
      state.currentUser = returnedUser;
      state.showLoginModal = false;
      // show game over screen if user has answered all questions OR if the game/round timeframe has concluded, otherwise send the user to the instructions screen

      let userCompletedRound = true;
      let roundQuestionIDs = state.currentUser.questions.filter(question => question.roundID === state.currentRound).map(question => question.masterQuestionID)
      roundQuestionIDs.forEach(questionID => {
        if(!state.currentUser.completedQuestions.includes(questionID)){
          userCompletedRound = false;
        }
      })

      getVal(roundsRef).then((snapshot) => {
        // get unix timestamp for RIGHT NOW
        let curTime = Math.floor(Date.now() / 1000)
        let currentRoundEndTime = null;
        for(const [key, value] of Object.entries(snapshot.val())){
          console.log(key);
          if(value.id === state.currentRound){
            currentRoundEndTime = value.endTime;
            break;
          }
        }

        if((curTime > currentRoundEndTime) || userCompletedRound){
          console.log(curTime)
          console.log(currentRoundEndTime)
          state.skipToEnd = true;
        }

        if(state.skipToEnd){
          state.currentView = 'gameover';
        }else{
          state.currentView = 'welcome';
        }

        // scroll to top for mobile
        window.scrollTo({ top: 0, behavior: 'smooth' });
      })
    },
    logout(state){
      let loggedInRef = dbRef(db, `users/${state.currentUser.id}/loggedIn`);
      setVal(loggedInRef, false);
      onDisconnect(loggedInRef).cancel();

      state.currentUser = null;
      state.showLogoutModal = false;
      state.skipToEnd = false;
      state.currentView = 'welcome';

      // stop updating heartbeat for user if necessary
      clearInterval(state.heartbeatIntervalID);
      state.heartbeatIntervalID = null;

      // scroll to top for mobile
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    startHeartbeat(state){
      let lastSeenRef = dbRef(db, `users/${state.currentUser.id}/lastSeen`);
      state.heartbeatIntervalID = setInterval(() => {
        setVal(lastSeenRef, (Math.floor(Date.now()/1000)));
      }, 5000);
    },
    updateCurrentRound(state, newRound){
      state.currentRound = newRound;
    },
    updateCurrentQuestionID(state, newQuestionID){
      state.currentQuestionID = newQuestionID;
    },
    updateCurrentView(state, newView){
      state.currentView = newView;
      // scroll to top for mobile
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    updateErrorMessage(state, newMessage){
      state.errorMessage = newMessage;
    },
    toggleErrorModal(state){
      state.showErrorModal = !state.showErrorModal;
    },
    toggleErrorModalLock(state, newLockState){
      state.lockErrorModal = newLockState;
      console.log(newLockState)
    },
    toggleLeaderboardModal(state){
      state.showLeaderboardModal = !state.showLeaderboardModal;
    },
    togglePerformanceModal(state){
      state.showPerformanceModal = !state.showPerformanceModal;
    },
    toggleHelpModal(state){
      state.showHelpModal = !state.showHelpModal;
    },
    toggleLoginModal(state){
      state.showLoginModal = !state.showLoginModal;
    },
    toggleLogoutModal(state){
      state.showLogoutModal = !state.showLogoutModal;
    },
    toggleUserModal(state){
      state.showUserModal = !state.showUserModal;
    },
    toggleNavItems(state){
      state.disableNavItems = !state.disableNavItems;
    },
    updateUsers(state, newUsers){
      state.users = newUsers;
      if(state.currentUser){
        let updatedCurrentUser = newUsers.find(user => user.id === state.currentUser.id)
        state.currentUser = updatedCurrentUser;
      }
    },
    updateRounds(state, newRounds){
      state.rounds = newRounds;
    },
    updateLockedStatus(state, newStatus){
      state.unlocked = newStatus;
    },
    toggleLoginError(state, errorDetails){
      state.loginErrorMessage = errorDetails.message;
      state.showLoginErrorMessage = errorDetails.visible;
    },
    toggleUserError(state, errorDetails){
      state.userErrorMessage = errorDetails.message;
      state.showUserErrorMessage = errorDetails.visible;
    },
    updateCameraPermissions(state, newPermissionStatus){
      state.cameraPermissionGranted = newPermissionStatus;
    },
    toggleReaderVisibility(state, newVisibility){
      state.showReader = newVisibility;
    },
    toggleLoggedInStatus(state, newStatus){
      if(state.currentUser.id){
        let loggedInRef = dbRef(db, `users/${state.currentUser.id}/loggedIn`);
        setVal(loggedInRef, newStatus);
      }
    },
    updateQuestionFloatDelay(state, newDelay){
      state.questionFloatDelay = newDelay;
    },
    updateUserCredentials(state, newCredentials){
      if(state.currentUser.id){
        let userCredentialsRef = dbRef(db, `users/${state.currentUser.id}/password`);
        setVal(userCredentialsRef, newCredentials.updatedPassword);
      }
    },
  },
  actions: {
    onResize({commit}){
      commit('onResize', window.innerWidth)
    },
    login({commit, state}, userCredentials){
      let returnedUser = null;

      /* TODO - ADJUST TO CHECK CREDENTIALS AGAINST SELECTED USER INFO ON USER REF */
        /* going to really be dependent on what the "auth" method ends up being, honestly */
      // getVal(passwordRef).then((snapshot) => {
        // if(userCredentials.password === snapshot.val()){
        let requestedUser = state.users.find(user => user.id === userCredentials.id);

        if(userCredentials.password === requestedUser.password){
          returnedUser = requestedUser;

          let loggedInRef = dbRef(db, `users/${returnedUser.id}/loggedIn`);

          getVal(loggedInRef).then((loggedInSnapshot) => {
            // if not logged in, mark logged in and log the user in
            if(loggedInSnapshot.val() === false){
              // record login
              let loginDetails = {
                user: returnedUser.id,
                email: returnedUser.email,
                timestamp: serverTimestamp()
              }
              onDisconnect(loggedInRef).set(false);
              setVal(loggedInRef, true);
              dbPush(loginsRef, loginDetails);
              // assign returned user info to currentUser
              commit('login', returnedUser)
              commit('toggleLoginError', {message: '', visible: false});
              // start heartbeat
              commit('startHeartbeat')

            }else{ // otherwise toggle login error
              commit('toggleLoginError', {message: 'User already logged in.', visible: true})
            }
          })
        }else{
          commit('toggleLoginError', {message: 'Incorrect password.', visible: true})
          // returnedUser = state.users.find(user => user.id === userCredentials.id)
        }
      // })
    },
    logout({commit}){
      commit('logout')
    },
    updateCurrentQuestionID({commit}, newQuestionID){
      commit('updateCurrentQuestionID', newQuestionID)
    },
    updateCurrentRound({commit}, newRound){
      commit('updateCurrentRound', newRound)
    },
    updateCurrentView({commit}, newView){
      commit('updateCurrentView', newView)
    },
    updateErrorMessage({commit}, newMessage){
      commit('updateErrorMessage', newMessage)
    },
    toggleErrorModal({commit}){
      commit('toggleErrorModal')
    },
    toggleErrorModalLock({commit}, newLockState){
      commit('toggleErrorModalLock', newLockState)
    },
    toggleLeaderboardModal({commit}){
      commit('toggleLeaderboardModal')
    },
    togglePerformanceModal({commit}){
      commit('togglePerformanceModal')
    },
    toggleHelpModal({commit}){
      commit('toggleHelpModal')
    },
    toggleLoginModal({commit}){
      commit('toggleLoginModal')
    },
    toggleLogoutModal({commit}){
      commit('toggleLogoutModal')
    },
    toggleUserModal({commit}){
      commit('toggleUserModal')
    },
    toggleNavItems({commit}){
      commit('toggleNavItems')
    },
    updateUserScore({state}, newPoints){
      let curScore = state.currentUser.score;
      let scoreRef = dbRef(db, `users/${state.currentUser.id}/score`)
      setVal(scoreRef, (curScore + newPoints));
    },
    updateUserCompletedQuestions({state}, completedQuestionDetails){
      if(!state.currentUser.completedQuestions.includes(completedQuestionDetails.masterQuestionID)){
        // add to completed question list
        let currentUserCompletedRef = dbRef(db, `users/${state.currentUser.id}/completedQuestions`)
        dbPush(currentUserCompletedRef, completedQuestionDetails.masterQuestionID);

        // mark correct if user answered correctly
        let completedQuestionCorrectRef = dbRef(db, `users/${state.currentUser.id}/questions/${completedQuestionDetails.questionRefID}/answeredCorrectly`);
        setVal(completedQuestionCorrectRef, completedQuestionDetails.answeredCorrectly);

        // record user's time to complete the question
        let completedQuestionTimeSpentRef = dbRef(db, `users/${state.currentUser.id}/questions/${completedQuestionDetails.questionRefID}/timeSpent`);
        setVal(completedQuestionTimeSpentRef, completedQuestionDetails.timeSpent);

        // record user's awarded point value for the question
        let completedQuestionPointsEarnedRef = dbRef(db, `users/${state.currentUser.id}/questions/${completedQuestionDetails.questionRefID}/pointsEarned`);
        setVal(completedQuestionPointsEarnedRef, completedQuestionDetails.pointsEarned);
      }
    },
    updateUserViewedQuestions({state}, masterQuestionID){
      if(!state.currentUser.viewedQuestions.includes(masterQuestionID)){
        let currentUserViewedRef = dbRef(db, `users/${state.currentUser.id}/viewedQuestions`)
        dbPush(currentUserViewedRef, masterQuestionID);
      }
    },
    updateUsers({commit}, newUsers){
      commit('updateUsers', newUsers);
    },
    updateRounds({commit}, newRounds){
      commit('updateRounds', newRounds);
    },
    updateLockedStatus({commit}, newStatus){
      commit('updateLockedStatus', newStatus);
    },
    toggleLoginError({commit}, errorDetails){
      commit('toggleLoginError', errorDetails);
    },
    toggleLoggedInStatus({commit}, newStatus){
      commit('toggleLoggedInStatus', newStatus);
    },
    updateQuestionFloatDelay({commit}, newDelay){
      commit('updateQuestionFloatDelay', newDelay);
    },
    toggleUserError({commit}, errorDetails){
      commit('toggleUserError', errorDetails);
    },
    updateUserCredentials({commit, state}, newCredentials){
      if(newCredentials.currentPassword !== state.currentUser.password){
        commit('toggleUserError', {message: 'Current password is incorrect.', visible: true});
      }else if(newCredentials.updatedPassword !== newCredentials.updatedPasswordConfirmation){
        commit('toggleUserError', {message: 'New passwords do not match.', visible: true});
      }else{ // otherwise update credentials
        commit('toggleUserError', {message: '', visible: false});
        commit('updateUserCredentials', newCredentials);
        commit('toggleUserModal');
      }
    },
  },
  getters: {
    db: () => db,
    loginsRef: () => loginsRef,
    usersRef: () => usersRef,
    roundsRef: () => roundsRef,
    unlockedRef: () => unlockedRef,
    // passwordRef: () => passwordRef,
    // endTimeRef: () => endTimeRef,
    clientWidth: state => state.clientWidth,
    moduleTitle: state => state.moduleTitle,
    moduleAssetFolderName: state => state.moduleAssetFolderName,
    questionTime: state => state.questionTime,
    questionTimeDelay: state => state.questionTimeDelay,
    questionFloatDelay: state => state.questionFloatDelay,
    breakpoints: state => state.breakpoints,
    disclaimer: state => state.disclaimer,
    users: state => state.users,
    rounds: state => state.rounds,
    unlocked: state => state.unlocked,
    currentUser: state => state.currentUser,
    currentRound: state => state.currentRound,
    currentQuestionID: state => state.currentQuestionID,
    currentView: state => state.currentView,
    errorMessage: state => state.errorMessage,
    lockErrorModal: state => state.lockErrorModal,
    showErrorModal: state => state.showErrorModal,
    showLeaderboardModal: state => state.showLeaderboardModal,
    showPerformanceModal: state => state.showPerformanceModal,
    showHelpModal: state => state.showHelpModal,
    showLoginModal: state => state.showLoginModal,
    showLogoutModal: state => state.showLogoutModal,
    showUserModal: state => state.showUserModal,
    showUserErrorMessage: state => state.showUserErrorMessage,
    userErrorMessage: state => state.userErrorMessage,
    showLoginErrorMessage: state => state.showLoginErrorMessage,
    loginErrorMessage: state => state.loginErrorMessage,
    skipToEnd: state => state.skipToEnd,
    disableNavItems: state => state.disableNavItems,
    randomizedQuestionOrder: state => state.randomizedQuestionOrder,
    showLeaderboardRegions: state => state.showLeaderboardRegions,
    leaderboardMaxLength: state => state.leaderboardMaxLength,
  },
  modules: {

  }
});